"use client"

import type { ReactNode } from "react"

import { HomeTile, HomeTileSkeleton } from "@/features/dashboard/home-d4/components/home-tile"
import { ChurchTileError } from "@/features/finance/overview/church-f3/components/church-tile-parts"

/**
 * One state machine for every self-drawn board tile (F3, F1): skeleton while loading, a plain error with a retry,
 * else the tile. The fixed height makes the engine's rows line up like the design; a tile with nothing to show in
 * this period nor the previous one (`compact`) sizes to its one line instead.
 */
export function BoardTileStates({
  id,
  testIdPrefix,
  heightClass,
  title,
  isLoading,
  isError,
  onRetry,
  compact = false,
  children,
}: {
  id: string
  /** `church` or `branch`: keeps each board's test ids stable. */
  testIdPrefix: string
  heightClass: string
  title: string
  isLoading: boolean
  isError: boolean
  onRetry: () => void
  compact?: boolean
  children: () => ReactNode
}) {
  const shrink = compact && !isLoading && !isError
  return (
    <div data-testid={`${testIdPrefix}-frame-${id}`} className={shrink ? "h-auto" : heightClass}>
      {isLoading ? (
        <HomeTileSkeleton testId={`${testIdPrefix}-skeleton-${id}`} />
      ) : isError ? (
        <HomeTile title={title}>
          <ChurchTileError onRetry={onRetry} />
        </HomeTile>
      ) : (
        children()
      )}
    </div>
  )
}
